import { createApp } from "vue";
import { setActivePinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { pinia } from "./stores";
import { useUIStore } from "./stores/useUIStore";
import "./assets/tailwind.css";
import "./assets/main.css";
import { createI18n } from "vue-i18n";
import { defaultLocale, messages } from "./locales/localization";
import clickOutside from "./directives/click-outside";
import safeHtml from "./directives/safe-html";
import GlobalError from "./components/globalError/GlobalError.vue";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import CustomerHelper from "@/helpers/customerHelper";
import { loadPublicInfo } from "@/services/marketTenantService";

const resolvedLocale = navigator.language.includes("es")
  ? "es-ES"
  : navigator.language.includes("en")
  ? "en-US"
  : navigator.language;

// Reflect locale in the HTML lang attribute for search engines and screen readers
document.documentElement.lang = resolvedLocale.split("-")[0]; // "es" | "en" | "ca"

const i18n = createI18n({
  legacy: false,
  locale: resolvedLocale,
  fallbackLocale: defaultLocale as string,
  messages,
  fallbackWarn: false,
  silentTranslationWarn: true,
});

//Mapping to translate navigator.language options to flatpickr languagesm get 'en' as default because defaultLocale is 'en-US'
const storeLocale = navigator.language.includes("es")
  ? "es"
  : navigator.language.includes("en")
  ? "en"
  : navigator.language.includes("ca")
  ? "cat"
  : "en";
//TODO INFO: Para cuando tengamos que cambiar el idioma dependiendo del usuario hacemos overwrite del mapping de storeLocale
setActivePinia(pinia);
useUIStore().setLocale(storeLocale);

async function bootstrap() {
  // Rehidrata la sesión desde la cookie HttpOnly (token en memoria para naavi).
  await CustomerHelper.ensureValidSession();

  let googleMapsApiKey = "";
  try {
    const publicInfo = await loadPublicInfo();
    if (publicInfo && publicInfo.googleMapsApiKey) {
      googleMapsApiKey = publicInfo.googleMapsApiKey;
    }
  } catch (error) {
    void error;
  }

  const app = createApp(App)
    .component("GlobalError", GlobalError)
    .directive("click-outside", clickOutside)
    .directive("safe-html", safeHtml)
    .use(pinia)
    .use(router)
    .use(i18n);
  app.use(VueGoogleMaps, {
    load: {
      key: googleMapsApiKey,
      libraries: ["places", "marker"],
      v: "weekly",
      loading: "async",
    },
  });
  await router.isReady();
  app.mount("#app");
}

bootstrap();
